import clsx from "clsx";
import { GenericInfoPopup, Icon, IconName, useDeviceTypes } from "halifax";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router";
import {
  CallState,
  MODAL_ALERT,
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
} from "redmond";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";

import { PATH_HOME } from "../../../../utils/paths";
import { ReviewErrorModalConnectorProps } from "./container";
import "./styles.scss";
import * as textConstants from "./textConstants";

export interface IAvailabilityErrorModalProps
  extends ReviewErrorModalConnectorProps,
    RouteComponentProps {
  returnToShop: () => void;
}

export const ReviewErrorModal = (props: IAvailabilityErrorModalProps) => {
  const { finalizePackageCallState, history, returnToShop } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { matchesMobile } = useDeviceTypes();

  const modalEventProperties = {
    type: "hotels_shop_error",
    primary_button: textConstants.SEARCH_AGAIN_BUTTON,
    secondary_button: textConstants.GO_BACK_BUTTON,
    screen: ModalScreens.HOTELS_SHOP,
    category: ModalCategoryType.TROUBLE,
    funnel: "packages",
  };

  const hasFailed = finalizePackageCallState === CallState.Failed;

  React.useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const buttons = [
    {
      buttonText: textConstants.GO_BACK_BUTTON,
      buttonWrapperClassName: clsx(
        "availability-error-modal-button",
        "secondary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.SECONDARY,
          },
        });
        history.push(PATH_HOME);
      },
    },
    {
      buttonText: textConstants.SEARCH_AGAIN_BUTTON,
      buttonWrapperClassName: clsx(
        "availability-error-modal-button",
        "primary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.SECONDARY,
          },
        });
        returnToShop();
      },
    },
  ];

  return (
    <GenericInfoPopup
      className="review-error-modal-root"
      open={isOpen}
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      title={textConstants.REVIEW_ERROR_TITLE}
      subtitle={textConstants.REVIEW_ERROR_SUBTITLE}
      buttons={buttons}
      isMobile={matchesMobile}
    />
  );
};
